import React, { FunctionComponent } from 'react';

import { DonateButton } from '../DonateButton/DonateButton';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  return (
    <>
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        successType="StaticDonateButtonClick"
        experiments={[]}
      />
      <Share successType="StaticShareButtonClick" />
    </>
  );
};

export default FundraisingCTA;
